<template>
	<section>
		<h1 class="title is-1">Editar producto</h1>
		<b-breadcrumb
            align="is-left"
        >
            <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
            <b-breadcrumb-item tag='router-link' to="/inventario">Inventario</b-breadcrumb-item>
            <b-breadcrumb-item  active>Editar producto</b-breadcrumb-item>
        </b-breadcrumb>     
		<form-producto :productoProp="datosProducto"  @registrado="onEditar" v-if="datosProducto" />
	</section>
</template>
<script>
	import HttpService from '../../Servicios/HttpService'
	import FormProducto from './FormProducto'
	import { NotificacionesMixin } from "../../components/mixins/NotificacionesMixin";

	export default{
		name: "EditarProducto",
		components: { FormProducto },
		mixins: [NotificacionesMixin],

		data:()=>({
			cargando: false,
			datosProducto: null,
			datosProductos:null,
			usuario:"",
			productos:null,
			
		}),

		async mounted(){
			this.cargando = true
			const producto = await HttpService.obtenerConConsultas('productos.php', {
				accion: 'obtener_por_id',
				id: this.$route.params.id
			})
			this.datosProducto = producto
			this.cargando = false
			document.title = 'Editar/Producto'; 
			
		},

		methods: { 
			async onEditar(datosProducto,productos) {
				this.cargando = true
				this.usuario = localStorage.getItem('nombreUsuario');
				const resultado = await HttpService.editar('productos.php',{
					accion: 'editar',
					producto: datosProducto,
					usuario:  this.usuario,
					productos: productos,
				})

				if(resultado) {
					this.cargando = false
					this.mostrarNotificacion("success", `Producto ${datosProducto.nombre} actualizado correctamente`);
                    this.$router.push({ name: 'ProductosComponent'})
				}
			}
		}
	}
</script>